import type { FC } from "react";
import React from "react";
import { Icons } from "@/components/NavIcon";
import { baseSelector as userSelector } from "@/features/userSlice";
import { useAppSelector } from "@/storeHooks";
import css from "./AppHeader.module.css";

const UserInfo: FC<{ testId?: string }> = ({ testId = "user-info" }) => {
  const { firstName, lastName, roles, customerName } =
    useAppSelector(userSelector);

  return (
    <aside data-testid={testId} className={css.userInfo}>
      <Icons.AccountCircleIcon />
      <ul>
        <li>{`${firstName} ${lastName}`.trim()}</li>
        <li>
          <span className={css.customerName}>{customerName}</span>
          <span aria-label="User roles">{roles.join(", ")}</span>
        </li>
      </ul>
    </aside>
  );
};

export default UserInfo;
